import React, { useState } from "react";
import shareIcon from "../../assets/dasboard/share-icon.svg";
import { getColorCode, getImage } from "../../utils/utility-functions";
import ShareProfileModal from "../share-modal/component";

function ShareButton({
  currentAssessmentAttemptData,
  userGUID,
  userData,
  isRomanticCompatibility,
  assessmentAttemptResultId,
  saveUserSocialButtonClickConnect,
  // Opt-in presentation API — every existing caller omits both, so
  // `variant` defaults to "icon" and renders byte-for-byte the same
  // circular icon-only button as before. "pill" is additive only.
  variant = "icon",
  label,
}) {
  const [selectedTest, setSelectedTest] = useState(null);

  const [shareModalOpen, setShareModalOpen] = useState(false);
  const currentPersonalityGroup = currentAssessmentAttemptData
    ? currentAssessmentAttemptData?.personality?.role
    : "";

  const personalityColorLight = getColorCode(
    currentPersonalityGroup && currentPersonalityGroup,
  ).light;

  const handleShareReport = (item) => {
    setShareModalOpen(true);
    setSelectedTest(item);
  };

  const isPill = variant === "pill";

  return (
    <div>
      <button
        onClick={() => {
          handleShareReport(currentAssessmentAttemptData);
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = personalityColorLight)
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor = "transparent")
        }
        className={
          isPill
            ? "inline-flex flex-shrink-0 items-center gap-1 sm:gap-2 min-h-[44px] px-1 sm:px-4 py-2.5 rounded-full bg-gray-100 border border-gray-200 text-gray-700 font-medium text-sm hover:bg-gray-200 transition-colors"
            : "aspect-square w-max bg-[#d9d9d9] rounded-full flex items-center justify-center"
        }
      >
        <img
          src={shareIcon}
          alt="Sharing"
          className={
            isPill
              ? "w-3.5 h-3.5 sm:w-5 sm:h-5 flex-shrink-0"
              : "w-[40px] h-auto hover:text-insightful-purple"
          }
        />
        {isPill && label && <span className="whitespace-nowrap">{label}</span>}
      </button>
      {shareModalOpen && (
        <ShareProfileModal
          isOpen={shareModalOpen}
          onClose={() => setShareModalOpen(false)}
          personalityImage={getImage(
            selectedTest?.personality?.role?.toLowerCase() &&
              selectedTest?.personality?.role?.toLowerCase(),

            selectedTest?.nameEnglishCode?.toLowerCase() &&
              selectedTest?.nameEnglishCode?.toLowerCase(),
            true,
            userData?.gender,
          )}
          assessmentTitle={
            selectedTest?.title || currentAssessmentAttemptData.assessmentTitle
          }
          assessmentId={
            selectedTest?.assessmentId && selectedTest?.assessmentId
          }
          assessmentAttemptId={
            selectedTest?.assessmentAttemptId &&
            selectedTest?.assessmentAttemptId
          }
          personalityType={
            selectedTest?.personality?.title && selectedTest?.personality?.title
          }
          personalityName={
            selectedTest?.personality?.name && selectedTest?.personality?.name
          }
          personalityGroup={
            selectedTest?.personality?.role && selectedTest?.personality?.role
          }
          userGUID={userGUID}
          isRomanticCompatibility={isRomanticCompatibility}
          assessmentAttemptResultId={assessmentAttemptResultId}
          saveUserSocialButtonClickConnect={saveUserSocialButtonClickConnect}
        />
      )}
    </div>
  );
}

export default ShareButton;
